import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const SocialIcon = ({ platform }) => {
  switch (platform) {
    case 'linkedin':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3A1.97 1.97 0 0 0 3.28 4.97c0 1.08.88 1.97 1.94 1.97h.03a1.97 1.97 0 1 0 0-3.94ZM20.72 13.02c0-3.46-1.85-5.07-4.32-5.07-1.99 0-2.88 1.1-3.38 1.87V8.5H9.64c.04.88 0 11.5 0 11.5h3.38v-6.42c0-.34.02-.68.12-.92.27-.68.88-1.39 1.91-1.39 1.35 0 1.89 1.03 1.89 2.54V20H20.7l.02-6.98Z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.8A3.95 3.95 0 0 0 3.8 7.75v8.5a3.95 3.95 0 0 0 3.95 3.95h8.5a3.95 3.95 0 0 0 3.95-3.95v-8.5a3.95 3.95 0 0 0-3.95-3.95h-8.5Zm8.9 1.35a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM12 6.85A5.15 5.15 0 1 1 6.85 12 5.16 5.16 0 0 1 12 6.85Zm0 1.8A3.35 3.35 0 1 0 15.35 12 3.35 3.35 0 0 0 12 8.65Z" />
        </svg>
      );
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M13.5 21v-7.16h2.4l.36-2.8H13.5V9.26c0-.81.22-1.36 1.39-1.36H16.4V5.4c-.26-.03-1.15-.1-2.18-.1-2.16 0-3.64 1.31-3.64 3.74v2.1H8.14v2.8h2.44V21h2.92Z" />
        </svg>
      );
    case 'tiktok':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.72 3c.21 1.75 1.2 3.28 2.67 4.18.96.59 2.11.9 3.28.9v2.78a8.67 8.67 0 0 1-3.18-.61v5.24c0 3.42-2.77 6.2-6.2 6.2a6.2 6.2 0 1 1 0-12.4c.31 0 .62.03.92.08v2.88a3.34 3.34 0 0 0-.92-.13 3.4 3.4 0 1 0 3.43 3.4V3h2Z" />
        </svg>
      );
    case 'youtube':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21.58 7.19a2.98 2.98 0 0 0-2.1-2.1C17.6 4.5 12 4.5 12 4.5s-5.6 0-7.48.59a2.98 2.98 0 0 0-2.1 2.1A31.9 31.9 0 0 0 1.83 12c0 1.62.2 3.23.59 4.81a2.98 2.98 0 0 0 2.1 2.1c1.88.59 7.48.59 7.48.59s5.6 0 7.48-.59a2.98 2.98 0 0 0 2.1-2.1c.39-1.58.59-3.19.59-4.81s-.2-3.23-.59-4.81ZM9.75 15.03V8.97L15 12l-5.25 3.03Z" />
        </svg>
      );
    case 'x':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18.9 3H21l-4.58 5.23L21.8 21h-4.22l-3.3-4.34L10.48 21H8.36l4.9-5.6L2.8 3h4.32l2.99 3.94L13.55 3h2.12Zm-1.48 16.4h1.17L6.45 4.52H5.2L17.42 19.4Z" />
        </svg>
      );
    default:
      return null;
  }
};

const Footer = ({ text, lang }) => {
  const navigate = useNavigate();

  const handleServiceClick = (path) => {
    navigate(path);
    // Scroll to top when navigating to service pages
    window.scrollTo(0, 0);
  };

  // Format phone number for Arabic mode
  const formatPhoneNumber = (phoneText) => {
    if (lang === 'ar') {
      // In Arabic mode, make the entire number read left to right with Arabic letters
      return (
        <span style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}>
          {phoneText}
        </span>
      );
    }
    return phoneText;
  };

  const socialLinks = [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/in/first-luxury-logistics-services-company-706206294/',
      label: 'LinkedIn'
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/first.luxurylogistics?igsh=YzUyb2dkY2RqMGpu',
      label: 'Instagram'
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/profile.php?id=61590789891138',
      label: 'Facebook'
    },
    {
      id: 'tiktok',
      href: 'https://www.tiktok.com/@1firstluxury',
      label: 'TikTok'
    },
    {
      id: 'youtube',
      href: 'https://www.youtube.com/@FirstLuxuryLogisticsServices',
      label: 'YouTube'
    },
    {
      id: 'x',
      href: 'https://x.com/services8036',
      label: 'X'
    }
  ];

  return (
    <footer className="footer advanced-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand true-left">
            <div className="footer-logo-container">
              <img src="/images/updatedlogo.png" alt="1st Luxury Logo" className="footer-logo-img" loading="lazy" decoding="async"/>
              <div className="footer-logo-text">
                <h3>{text.footerCompanyName}</h3>
                <p>{text.footerCompanyDesc}</p>
              </div>
            </div>
          </div>
          <div className="footer-sections">
            <div className="footer-section">
              <h4>{text.footerOurServicesTitle}</h4>
              <ul>
                <li><button onClick={() => handleServiceClick('/freight-services')} className="footer-service-link">{lang === 'ar' ? 'خدمات الشحن' : 'Freight Services'}</button></li>
                <li><button onClick={() => handleServiceClick('/logistics-solutions')} className="footer-service-link">{lang === 'ar' ? 'الحلول اللوجستية' : 'Logistics Solutions'}</button></li>
                <li><button onClick={() => handleServiceClick('/comprehensive-services')} className="footer-service-link">{lang === 'ar' ? 'الخدمات الشاملة' : 'Comprehensive Services'}</button></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>{text.footerContactTitle}</h4>
              <div className="footer-contact-info">
                <p><i className="fas fa-map-marker-alt"></i> <span dangerouslySetInnerHTML={{ __html: text.footerAddress }}></span></p>
                <p><i className="fas fa-phone"></i> {formatPhoneNumber(text.footerPhone)}</p>
                <p><i className="fas fa-envelope"></i> {text.footerEmail}</p>
                <p><i className="fas fa-clock"></i> {text.footerSupport}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <span className="footer-copyright">{text.footerCopyright}</span>
            <div className="footer-social-links" aria-label="Social media links">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="footer-social-link"
                >
                  <SocialIcon platform={social.id} />
                </a>
              ))}
            </div>
            <div className="footer-bottom-links">
              <Link to="/privacy" aria-label={text.footerPrivacy} className="footer-link">{text.footerPrivacy}</Link>
              <Link to="/terms" aria-label={text.footerTerms} className="footer-link">{text.footerTerms}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 